var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape = function SvgShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17 0 8l1.414-1.414L9 14.171 22.586.586 24 2 9 17Z",
    fill: "#159D27"
  })));
};
export { SvgShape as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 24 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M9 17L0 8L1.414 6.586L9 14.171L22.586 0.585999L24 2L9 17Z' fill='%23159D27'/%3E %3C/svg%3E";